import { Box, Grid, Skeleton } from '@mui/material';
import { useQuery } from 'react-query';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import Subtitle from 'src/components/Subtitle';
import { getFiagroLiabilityData } from 'src/services/operation/operationFiagro';

import { FiagroCompetence } from '../../components/FiagroCompetence';
import { formatCompetence, getMostRecentLiabilityValue } from '../utils';

interface LiabilityDataProps {
  hash: string;
}

export default function LiabilityData({ hash }: LiabilityDataProps) {
  const { data, isLoading } = useQuery({
    queryKey: ['operationFIAGROLiabilityRecent', hash],
    queryFn: () => getFiagroLiabilityData(hash, 1),
    enabled: !!hash,
  });

  const mostRecent = data?.[0];
  const competence = mostRecent?.dataReferencia
    ? formatCompetence(mostRecent.dataReferencia)
    : 'N/D';

  const { passivo, patrimonioLiquido } =
    getMostRecentLiabilityValue(mostRecent);

  if (isLoading) {
    return (
      <Box>
        <Skeleton
          variant="text"
          width={150}
          height={20}
          sx={{ mb: 1, mt: 3 }}
        />
        <Box sx={{ height: 2, backgroundColor: 'black', mb: 2 }} />
        <Box display="flex" gap={2}>
          <Skeleton variant="rectangular" width="25%" height={150} />
          <Skeleton variant="rectangular" width="25%" height={150} />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Subtitle title="Dados" />
      <FiagroCompetence competence={competence} />
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <PaperPanelInfo numeric title="Passivo" value={passivo ?? 'N/D'} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <PaperPanelInfo
            numeric
            title="Patrimônio Líquido"
            value={patrimonioLiquido ?? 'N/D'}
          />
        </Grid>
      </Grid>
    </>
  );
}
